module.exports = __webpack_public_path__ + "img/ic-spklu-blue.c261f328.svg";